import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { reportGuestMisconduct } from 'modules/accommodations/features/reservations/api';

export const useMutationReportGuestMisconduct = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(reportGuestMisconduct, {
    onSuccess: data => {
      if (data.success) successToast(t('Guest misconduct successfully reported'));
    },
    onError: () => errorToast(),
  });
};
